const Counter = ({ count, icon }) => {
  return (
    <div className="flex items-center gap-1">
      <span className="w-6 h-6 flex items-center justify-center">{icon}</span>
      <span className="text-brandGray2">{count}</span>
    </div>
  );
};

export default Counter;
